const tabifotoAdmin = {
  tabifotoAdmin: {
    nav: {
      content_section: "Content",
      operations_section: "Operations",
      dashboard: "Dashboard",
      services: "Services",
      portfolio: "Portfolio",
      homepage_display: "Homepage Display",
      content: "Content",
      orders: "Orders",
      photographers: "Photographers",
      photographer_applications: "Photographer Applications",
      photographer_availability: "Availability",
      booking_confirmations: "Booking Confirmations",
      legal_documents: "Legal Documents",
      booking_cost_items: "Booking Costs",
      booking_notes: "Booking Notes",
      order_cancellation_logs: "Cancellation Logs",
      order_reschedule_logs: "Reschedule Logs",
      relay: "Relay Center",
    },
    lang: {
      zh: "中文",
      en: "EN",
      ja: "日本語",
      label: "Language",
    },
    common: {
      save: "Save Changes",
      cancel: "Cancel",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      deactivate: "Deactivate",
      active: "Active",
      inactive: "Inactive",
      published: "Published",
      draft: "Draft",
      sort_order: "Sort",
      yes: "Yes",
      no: "No",
      actions: "Actions",
      loading: "Loading...",
      error_load: "Failed to load. Please retry.",
      retry: "Retry",
      empty: "No items yet.",
      confirm_delete: "Delete this item?",
      cannot_undone: "This action cannot be undone.",
      confirm_deactivate: "Deactivate this item?",
      deactivate_desc: "Records are kept — is_active will be set to false.",
      save_success: "Saved successfully",
      save_error: "Save failed. Please try again.",
      delete_success: "Deleted successfully",
      delete_error: "Delete failed",
      api_not_configured: "API not configured — showing demo data",
    },
    dashboard: {
      title: "Dashboard",
      subtitle: "TaBiFoTo CMS — Content & Operations",
      active_services: "Active Services",
      published_portfolio: "Published Portfolio",
      on_showreel: "On Showreel",
      featured_works: "Featured Works",
      active_content: "Active Content",
      service_options: "Service Options",
      data_tables: "Data Tables",
      reset_title: "Reset to Defaults",
      reset_desc: "Restore all data to initial mock values. Cannot be undone.",
      reset_button: "Reset Data",
      drafts_warning: "{{count}} portfolio draft(s) not published",
      inactive_warning: "{{count}} inactive service(s)",
    },
    services: {
      title: "Services Management",
      subtitle: "Manage services table — multilingual, pricing, city scope, and options",
      add_service: "Add Service",
      edit_service: "Edit Service",
      col_order: "#",
      col_image: "Image",
      col_code: "Code",
      col_title: "Title (ZH)",
      col_price: "Price TWD",
      col_hours: "Hours",
      col_cities: "Cities",
      col_active: "Active",
      col_sort: "Sort",
      col_options: "Options",
      col_actions: "Actions",
      service_code: "service_code",
      icon_class: "Icon Class",
      title_field: "Title",
      short_desc: "Short Description",
      features: "Features",
      add_feature: "+ Add Feature",
      base_price: "Base Price (NT$)",
      duration_hours: "Duration Hours",
      city_scope: "City Scope",
      cover_image: "Cover Image URL",
      no_options: "No options yet.",
      manage_options: "Options",
      add_option: "Add Option",
      edit_option: "Edit Option",
      option_code: "option_code",
      option_title: "Option Title",
      price_delta: "Price Delta (NT$)",
      deactivate_confirm: "Deactivate this service?",
      deactivate_desc: "Records are kept — is_active will be set to false.",
      opts_label: "{{count}} opts",
    },
    portfolio: {
      title: "Portfolio Management",
      subtitle: "Manage portfolio_items — showreel, featured, homepage display control",
      add_item: "Add Item",
      edit_item: "Edit Item",
      filter_all: "All",
      filter_published: "Published",
      filter_showreel: "Showreel",
      filter_featured: "Featured",
      col_order: "#",
      col_thumb: "Thumb",
      col_title: "Title",
      col_city: "City",
      col_shoot_type: "Type",
      col_showreel: "Showreel",
      col_featured: "Featured",
      col_published: "Published",
      col_display_mode: "Display Mode",
      col_sort: "Sort",
      col_actions: "Actions",
      title_field: "Title",
      photographer_id: "photographer_id",
      city: "City",
      shoot_type: "Shoot Type",
      media_type: "Media Type",
      thumbnail_url: "thumbnail_url",
      media_url: "media_url",
      description: "Description",
      display_mode: "homepage_display_mode",
      no_items: "No items match filter.",
      delete_confirm: "Delete this item?",
    },
    homepage: {
      title: "Homepage Display Control",
      subtitle: "Control which portfolio_items appear on the homepage showreel and featured section",
      on_showreel: "On Showreel",
      featured_works: "Featured Works",
      total_published: "Total Published",
      tab_showreel: "Showreel",
      tab_featured: "Featured Works",
      tab_all: "All Published",
      is_showreel: "is_showreel",
      is_featured: "is_featured",
      display_mode: "display_mode",
      sort_order_field: "sort_order",
      publish_first: "No published items yet. Publish items in Portfolio Management first.",
    },
    content: {
      title: "Content Management",
      subtitle: "Edit hero text, philosophy sections, and CTA — supports zh / en / ja",
      add_section: "Add Section",
      edit_section: "Edit Section",
      section_key: "section_key",
      image_url: "image_url",
      title_field: "Title",
      content_field: "Content",
      no_items: "No records in this section yet.",
      delete_confirm: "Delete this section?",
      records_count: "{{count}} record(s)",
      hero_label: "Hero",
      hero_desc: "Homepage hero headline, subheadline, background image & CTA text",
      philosophy_label: "Philosophy Page",
      philosophy_desc: "Philosophy page hero + 4 content sections",
      cta_label: "CTA Block",
      cta_desc: "Call-to-action title and body text across pages",
    },
    orders: {
      title: "Orders",
      subtitle: "View and manage customer booking requests — order and payment status tracking",
      add_order: "Add Order",
      edit_order: "Edit Order",
      filter_all: "All",
      col_order_number: "Order No.",
      col_customer: "Customer",
      col_city: "City",
      col_service: "Service",
      col_shoot_date: "Shoot Date",
      col_total: "Total",
      col_order_status: "Order Status",
      col_payment_status: "Payment",
      col_actions: "Actions",
      customer_name: "Customer Name",
      customer_email: "Email",
      customer_phone: "Phone",
      service_id: "Service",
      selected_city: "City",
      shoot_date: "Shoot Date",
      start_time: "Start Time",
      end_time: "End Time",
      number_of_reels: "No. of Reels",
      subtotal_twd: "Subtotal (NT$)",
      addons_total_twd: "Add-ons (NT$)",
      total_twd: "Total (NT$)",
      currency: "Currency",
      order_status: "Order Status",
      payment_status: "Payment Status",
      special_requests: "Special Requests",
      internal_notes: "Internal Notes",
      order_status_pending: "Pending",
      order_status_confirmed: "Confirmed",
      order_status_cancelled: "Cancelled",
      order_status_completed: "Completed",
      payment_status_unpaid: "Unpaid",
      payment_status_paid: "Paid",
      payment_status_refunded: "Refunded",
      payment_status_partial: "Partial",
      no_orders: "No orders yet.",
      delete_confirm: "Delete this order?",
      related_records: "Related Records",
      related_cost_items: "Cost Items",
      related_notes: "Notes",
      related_cancellations: "Cancellations",
      related_reschedules: "Reschedules",
      view_related: "View",
    },
    photographers: {
      title: "Photographers",
      subtitle: "Manage photographer operational records — status, languages, city base, contact",
      add_photographer: "Add Photographer",
      edit_photographer: "Edit Photographer",
      col_code: "Code",
      col_name: "Display Name",
      col_legal_name: "Legal Name",
      col_city_base: "City Base",
      col_languages: "Languages",
      col_status: "Status",
      col_active: "Active",
      col_actions: "Actions",
      photographer_code: "photographer_code",
      display_name: "Display Name",
      legal_name: "Legal Name",
      email: "Email",
      phone: "Phone",
      country_code: "Country Code",
      city_base: "City Base",
      languages: "Languages (comma-separated, e.g. zh,en,ja)",
      status: "Status",
      portfolio_url: "Portfolio URL",
      notes: "Notes",
      status_active: "Active",
      status_inactive: "Inactive",
      status_on_leave: "On Leave",
      status_suspended: "Suspended",
      deactivate_confirm: "Deactivate this photographer?",
      deactivate_desc: "Records are kept — is_active will be set to false.",
      no_photographers: "No photographers yet.",
      all_count: "{{count}} photographer(s)",
      gender_label: "Gender (for matching only)",
      gender_note: "This field is used only as a matching reference and is not exposed as a public filter.",
      gender_prefer_not_to_say: "Prefer not to say",
      gender_male: "Male",
      gender_female: "Female",
    },
    photographer_availability: {
      title: "Photographer Availability",
      subtitle: "Manage photographer availability windows — date, time, city, status",
      add_availability: "Add Availability",
      edit_availability: "Edit Availability",
      filter_all: "All",
      col_photographer: "Photographer",
      col_date: "Date",
      col_time: "Time Window",
      col_city: "City",
      col_status: "Status",
      col_note: "Note",
      col_actions: "Actions",
      photographer_id: "Photographer",
      available_date: "Available Date",
      available_start_time: "Start Time",
      available_end_time: "End Time",
      city: "City",
      status: "Status",
      note: "Note",
      status_available: "Available",
      status_booked: "Booked",
      status_blocked: "Blocked",
      no_availability: "No availability records yet.",
      delete_confirm: "Delete this availability record?",
    },
    booking_confirmations: {
      title: "Booking Confirmations",
      subtitle: "Manage photographer confirmation status for orders — confirm, decline, replacement",
      add_confirmation: "Add Confirmation",
      edit_confirmation: "Edit Confirmation",
      filter_all: "All",
      col_order: "Order",
      col_photographer: "Photographer",
      col_status: "Confirmation Status",
      col_confirmed_at: "Confirmed At",
      col_replacement: "Replacement",
      col_note: "Note",
      col_actions: "Actions",
      order_id: "Order",
      photographer_id: "Photographer",
      confirmation_status: "Confirmation Status",
      confirmed_at: "Confirmed At",
      declined_at: "Declined At",
      replacement_required: "Replacement Required",
      note: "Note",
      status_pending: "Pending",
      status_confirmed: "Confirmed",
      status_declined: "Declined",
      status_replacement_needed: "Replacement Needed",
      no_confirmations: "No booking confirmations yet.",
      delete_confirm: "Delete this confirmation?",
      unassigned: "Unassigned",
    },
    legal_documents: {
      title: "Legal Documents",
      subtitle: "Manage terms, privacy policy, and photo release — multilingual content support",
      add_document: "Add Document",
      edit_document: "Edit Document",
      filter_all: "All",
      col_doc_type: "Type",
      col_doc_key: "Doc Key",
      col_title: "Title",
      col_version: "Version",
      col_effective_date: "Effective Date",
      col_active: "Active",
      col_actions: "Actions",
      doc_type: "Document Type",
      doc_key: "Doc Key (system identifier)",
      title_field: "Title",
      content_field: "Content",
      version: "Version",
      effective_date: "Effective Date",
      no_documents: "No legal documents yet.",
      delete_confirm: "Delete this document?",
      doc_type_terms: "Terms of Service",
      doc_type_service_agreement: "Photography Service Agreement",
      doc_type_cancellation: "Cancellation & Reschedule Policy",
      doc_type_privacy: "Privacy Policy",
      doc_type_photo_release: "Photo Release",
      doc_type_photographer_contract: "Photographer Contract",
      doc_type_platform_disclaimer: "Platform Disclaimer",
      doc_type_cross_border: "Cross-Border Terms",
      audience: "Audience",
      required_for: "Required For",
      is_mandatory: "Mandatory",
      display_order: "Display Order",
      mandatory_yes: "Mandatory",
      mandatory_no: "Optional",
      col_required_for: "Required For",
    },
    booking_cost_items: {
      title: "Booking Cost Items",
      subtitle: "Track travel and accommodation costs per order — identify non-refundable items for cancellation and refund decisions",
      add_item: "Add Cost Item",
      edit_item: "Edit Cost Item",
      filter_all: "All",
      col_order: "Order",
      col_cost_type: "Cost Type",
      col_amount: "Amount",
      col_currency: "Currency",
      col_cost_status: "Status",
      col_description: "Description",
      col_created_at: "Created",
      col_actions: "Actions",
      order_id: "Order",
      cost_type: "Cost Type",
      amount_twd: "Amount (NT$)",
      currency: "Currency",
      cost_status: "Cost Status",
      description: "Description",
      cost_type_flight: "Flight",
      cost_type_train: "Train",
      cost_type_accommodation: "Accommodation",
      cost_type_local_transport: "Local Transport",
      cost_type_ticket: "Ticket",
      cost_type_other: "Other",
      cost_status_estimated: "Estimated",
      cost_status_booked: "Booked",
      cost_status_paid: "Paid",
      cost_status_non_refundable: "Non-Refundable",
      no_items: "No cost items yet.",
      delete_confirm: "Delete this cost item?",
      total_label: "Total",
      non_refundable_warning: "Non-refundable items require attention",
    },
    booking_notes: {
      title: "Booking Notes",
      subtitle: "Manage internal memos, customer-visible messages, and photographer instructions per order",
      add_note: "Add Note",
      filter_all: "All",
      col_order: "Order",
      col_note_type: "Type",
      col_content: "Content",
      col_created_by: "Created By",
      col_created_at: "Created",
      col_actions: "Actions",
      order_id: "Order",
      note_type: "Note Type",
      content: "Content",
      created_by: "Created By",
      note_type_internal: "Internal",
      note_type_customer_visible: "Customer Visible",
      note_type_photographer_visible: "Photographer Visible",
      no_notes: "No booking notes yet.",
      delete_confirm: "Delete this note?",
      content_placeholder: "Enter note content...",
    },
    order_cancellation_logs: {
      title: "Order Cancellation Logs",
      subtitle: "Audit log for order cancellations — refund amounts, penalties, and non-refundable cost breakdown",
      add_log: "Add Cancellation Log",
      edit_log: "Edit Cancellation Log",
      filter_all: "All",
      col_order: "Order",
      col_cancelled_at: "Cancelled At",
      col_cancelled_by: "Cancelled By",
      col_refund: "Refund",
      col_penalty: "Penalty",
      col_non_refundable: "Non-Refundable",
      col_actions: "Actions",
      order_id: "Order",
      cancelled_at: "Cancelled At",
      cancelled_by: "Cancelled By",
      reason: "Cancellation Reason",
      refund_amount_twd: "Refund Amount (NT$)",
      penalty_amount_twd: "Penalty Amount (NT$)",
      non_refundable_cost_twd: "Non-Refundable Cost (NT$)",
      note: "Note",
      no_logs: "No cancellation logs yet.",
      delete_confirm: "Delete this cancellation log?",
      financial_summary: "Financial Summary",
      by_customer: "Customer",
      by_ops: "Ops",
    },
    order_reschedule_logs: {
      title: "Order Reschedule Logs",
      subtitle: "Audit log for order reschedules — track date changes, reschedule count, and approval status",
      add_log: "Add Reschedule Log",
      edit_log: "Edit Reschedule Log",
      filter_all: "All",
      filter_pending: "Pending Approval",
      filter_approved: "Approved",
      col_order: "Order",
      col_original_date: "Original Date",
      col_new_date: "New Date",
      col_requested_at: "Requested At",
      col_approved_at: "Approved At",
      col_count: "Reschedule #",
      col_actions: "Actions",
      order_id: "Order",
      original_shoot_date: "Original Shoot Date",
      new_shoot_date: "New Shoot Date",
      requested_at: "Requested At",
      approved_at: "Approved At",
      reason: "Reason",
      reschedule_count: "Reschedule Count",
      note: "Note",
      no_logs: "No reschedule logs yet.",
      delete_confirm: "Delete this reschedule log?",
      pending_badge: "Pending",
      approved_badge: "Approved",
    },
    auth: {
      login_title: "Admin Login",
      login_subtitle: "TaBiFoTo Operations Panel",
      email_label: "Email",
      email_placeholder: "Enter admin email address...",
      password_label: "Password",
      password_placeholder: "Enter password...",
      login_button: "Login",
      logging_in: "Verifying...",
      login_error_invalid: "Invalid email or password, or account is inactive.",
      login_error_supabase: "Database not configured. Please check environment settings.",
      login_error_network: "Connection failed. Please try again.",
      logout: "Logout",
      logged_in_as: "Logged in as",
      bootstrapping: "Loading admin panel...",
      session_expired: "Session expired. Please log in again.",
    },
  },
};

export default tabifotoAdmin;
